function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _ManifestDefaultValues_brand = /*#__PURE__*/new WeakSet();
export class ManifestDefaultValues {
  constructor(externalStateHandler, externalPresetsHandler, manifestStore, manifestHelpers) {
    this.externalStateHandler = externalStateHandler;
    this.externalPresetsHandler = externalPresetsHandler;
    this.manifestStore = manifestStore;
    this.manifestHelpers = manifestHelpers;
    _classPrivateMethodInitSpec(this, _ManifestDefaultValues_brand);
  }
  getDefaultDataValueByEditorPointer(editorPointer, dataItemId) {
    var _manifest$data, _manifest$data2;
    const manifest = this.manifestStore.getManifestByEditorPointer(editorPointer);
    const type = this.manifestStore.getExtensionTypeByEditorPointer(editorPointer);
    const dataItem = manifest == null || (_manifest$data = manifest.data) == null ? void 0 : _manifest$data[dataItemId];
    const state = this.externalStateHandler.getState(editorPointer, type);
    if (dataItem && state) {
      /**
       * TODO: remove type casting,
       * also check ManifestResolver.filterItemsByState() methods, same issue there
       */
      const dataItemWithState = dataItem;
      let stateDefault;
      if (dataItemWithState.statesDefaultValue && state in dataItemWithState.statesDefaultValue) {
        stateDefault = dataItemWithState.statesDefaultValue[state];
      }
      if (stateDefault && stateDefault !== dataItem.defaultValue) {
        return stateDefault;
      }
    }
    return manifest == null || (_manifest$data2 = manifest.data) == null || (_manifest$data2 = _manifest$data2[dataItemId]) == null ? void 0 : _manifest$data2.defaultValue;
  }
  getDefaultCustomCssPropertyValueByEditorPointer(editorPointer, key) {
    var _manifest$cssCustomPr;
    const manifest = this.manifestStore.getManifestByEditorPointer(editorPointer);
    return _assertClassBrand(_ManifestDefaultValues_brand, this, _getDefaultStyleValue).call(this, editorPointer, key, manifest == null || (_manifest$cssCustomPr = manifest.cssCustomProperties) == null ? void 0 : _manifest$cssCustomPr[key]);
  }
  getDefaultCssPropertyValueByEditorPointer(editorPointer, key) {
    var _manifest$cssProperti;
    const manifest = this.manifestStore.getManifestByEditorPointer(editorPointer);
    return _assertClassBrand(_ManifestDefaultValues_brand, this, _getDefaultStyleValue).call(this, editorPointer, key, manifest == null || (_manifest$cssProperti = manifest.cssProperties) == null ? void 0 : _manifest$cssProperti[key]);
  }
  getDefaultStyleValueByEditorPointer(editorPointer, key) {
    var _manifest$cssProperti2, _manifest$cssCustomPr2;
    const manifest = this.manifestStore.getManifestByEditorPointer(editorPointer);
    if (!manifest) {
      return undefined;
    }
    if ((_manifest$cssProperti2 = manifest.cssProperties) != null && _manifest$cssProperti2[key]) {
      return this.getDefaultCssPropertyValueByEditorPointer(editorPointer, key);
    }
    if ((_manifest$cssCustomPr2 = manifest.cssCustomProperties) != null && _manifest$cssCustomPr2[key]) {
      return this.getDefaultCustomCssPropertyValueByEditorPointer(editorPointer, key);
    }
    return undefined;
  }
}
function _getDefaultStyleValue(editorPointer, key, item) {
  const type = this.manifestStore.getExtensionTypeByEditorPointer(editorPointer);
  const state = this.externalStateHandler.getState(editorPointer, type);
  if (item && state) {
    /**
     * TODO: remove type casting,
     * also check ManifestResolver.filterItemsByState() methods, same issue there
     */
    const styleItemWithState = item;
    let stateDefault;
    if (styleItemWithState.statesDefaultValue && state in styleItemWithState.statesDefaultValue) {
      stateDefault = styleItemWithState.statesDefaultValue[state];
    }
    if (stateDefault && stateDefault !== item.defaultValue) {
      return stateDefault;
    }
  }
  const presetKey = this.externalPresetsHandler.getAppliedPreset(editorPointer, type);
  return _assertClassBrand(_ManifestDefaultValues_brand, this, _findPresetOverrideInAncestors).call(this, editorPointer, key, presetKey) || (item == null ? void 0 : item.defaultValue);
}
function _findPresetOverrideInAncestors(editorPointer, key, presetKey) {
  var _editorPointer$innerE;
  if (!((_editorPointer$innerE = editorPointer.innerElementPath) != null && _editorPointer$innerE.length)) {
    return undefined;
  }
  const elements = this.manifestHelpers.structure.getAncestors(editorPointer);
  elements.push(editorPointer);
  for (const elementPointer of elements) {
    if (!elementPointer.innerElementPath) {
      continue;
    }
    const preset = _assertClassBrand(_ManifestDefaultValues_brand, this, _resolvePreset).call(this, elementPointer, presetKey);
    if (!preset) {
      continue;
    }
    const remainingPath = editorPointer.innerElementPath.slice(elementPointer.innerElementPath.length);
    let defaultValue;
    if (remainingPath.length === 0) {
      var _preset$presetDefault, _preset$presetDefault2;
      defaultValue = ((_preset$presetDefault = preset.presetDefaults) == null || (_preset$presetDefault = _preset$presetDefault.cssProperties) == null || (_preset$presetDefault = _preset$presetDefault[key]) == null ? void 0 : _preset$presetDefault.defaultValue) || ((_preset$presetDefault2 = preset.presetDefaults) == null || (_preset$presetDefault2 = _preset$presetDefault2.cssCustomProperties) == null || (_preset$presetDefault2 = _preset$presetDefault2[key]) == null ? void 0 : _preset$presetDefault2.defaultValue);
    }
    const ancestorDefaultValue = _assertClassBrand(_ManifestDefaultValues_brand, this, _getPresetValueByPath).call(this, preset, remainingPath);
    if (ancestorDefaultValue !== undefined) {
      var _ancestorDefaultValue, _ancestorDefaultValue2;
      defaultValue = ((_ancestorDefaultValue = ancestorDefaultValue.cssProperties) == null || (_ancestorDefaultValue = _ancestorDefaultValue[key]) == null ? void 0 : _ancestorDefaultValue.defaultValue) || ((_ancestorDefaultValue2 = ancestorDefaultValue.cssCustomProperties) == null || (_ancestorDefaultValue2 = _ancestorDefaultValue2[key]) == null ? void 0 : _ancestorDefaultValue2.defaultValue);
    }
    if (defaultValue !== undefined) {
      return defaultValue;
    }
  }
  return undefined;
}
function _resolvePreset(editorPointer, providedPresetKey) {
  var _editorPointer$innerE2;
  if (!editorPointer.innerElementPath || !editorPointer.innerElementPath.length) {
    return undefined;
  }
  if (!((_editorPointer$innerE2 = editorPointer.innerElementPath) != null && _editorPointer$innerE2.length)) {
    const store = this.manifestStore.getByEditorPointer(editorPointer);
    if (store) {
      var _store$manifest$insta;
      const presetKey = providedPresetKey || ((_store$manifest$insta = store.manifest.installation) == null || (_store$manifest$insta = _store$manifest$insta.presets) == null ? void 0 : _store$manifest$insta.large);
      if (presetKey) {
        var _store$manifest$edito;
        return (_store$manifest$edito = store.manifest.editorElement) == null || (_store$manifest$edito = _store$manifest$edito.presets) == null ? void 0 : _store$manifest$edito[presetKey];
      }
    }
  } else {
    const manifest = this.manifestStore.getManifestByEditorPointer(editorPointer);
    if (providedPresetKey) {
      var _manifest$presets;
      return manifest == null || (_manifest$presets = manifest.presets) == null ? void 0 : _manifest$presets[providedPresetKey];
    }
  }
  return undefined;
}
function _getPresetValueByPath(presetItem, path) {
  var _presetItem$presetDef;
  if (!path || !presetItem) {
    return undefined;
  }
  let data = (_presetItem$presetDef = presetItem.presetDefaults) == null || (_presetItem$presetDef = _presetItem$presetDef.elements) == null ? void 0 : _presetItem$presetDef[path[0]];
  for (const part of path.slice(1)) {
    var _data;
    if (!((_data = data) != null && (_data = _data.elements) != null && _data[part])) {
      return undefined;
    }
    data = data.elements[part];
  }
  return data;
}
//# sourceMappingURL=ManifestDefaultValues.js.map